import { action, observable } from 'mobx';

// data imports
import { imageProperties, CUSTOM_URL } from 'logic/data/Izenda.ReportPartKPIConstants';
/**
 * @class ImageTileProperties
 * @description contains property values for KPI Text tiles
 */
export default class ImageTileProperties {
    @observable image = imageProperties.image;
    @observable customURL = { option: CUSTOM_URL.DEFAULT_VALUE, url: '' }
    constructor(imageProperties) {
        if (imageProperties) {
            this.image = imageProperties.image;
            this.customURL = imageProperties.customURL;
        }
    }

    /**
     * @method updateProperties
     * @description reset property values with new values
     * @param {object} newProps changed properties
     */
    @action
    updateProperties(newProps) {
        Object.keys(newProps).forEach(key => this[key] = newProps[key]);
    }

    getStyle() {
        const {
            customURL
        } = this;
        const cursorType =  customURL && customURL.url == '' ? '' : 'pointer';
        return {
            cursor: cursorType
        };
    }
}



// WEBPACK FOOTER //
// ./ui/logic/models/ReportPartKPIModels/Izenda.ImageTileProperties.js